var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { CardInput } from ".";
import { Button, NumberInput, PasswordInput, RadioInput, SelectInput, TextInput } from "..";
import ReCAPTCHA from "react-google-recaptcha";
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 180px;\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-gap: 1rem;\n"], ["\n  min-width: 180px;\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-gap: 1rem;\n"])));
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-column: 1 / 7;\n  width: 100%;\n  max-width: ", ";\n  object-fit: contain;\n  justify-self: center;\n"], ["\n  grid-column: 1 / 7;\n  width: 100%;\n  max-width: ", ";\n  object-fit: contain;\n  justify-self: center;\n"])), function (_a) {
    var $maxWidth = _a.$maxWidth;
    return "".concat($maxWidth);
});
var ReCaptchaWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  grid-column: 1 / 7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  grid-column: 1 / 7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Header = styled.h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    margin: 0;\n    font-size: 1.2rem;\n    grid-column: 1/7;\n    color: ".concat(theme.colorContent(), ";\n  ");
});
// const Subheader = styled.h2`
//   ${({ theme }) => `
//     margin: 0;
//     font-size: 1rem;
//     grid-column: 1/7;
//     color: ${theme.colorContent()};
//   `}
// `;
var RadioWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  grid-column: 1/7;\n  display: flex;\n  flex-direction: column;\n"], ["\n  grid-column: 1/7;\n  display: flex;\n  flex-direction: column;\n"])));
var ExpirationWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  grid-column: 1/3;\n  display: grid;\n  align-items: end;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 1rem;\n"], ["\n  grid-column: 1/3;\n  display: grid;\n  align-items: end;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 1rem;\n"])));
var firstHalfColumns = {
    gridColumn: "1/4",
};
var secondHalfColumns = {
    gridColumn: "4/7",
};
var allColumns = {
    gridColumn: "1/7",
};
var expirationStyles = {
    width: "55px",
};
var cvvStyles = {
    gridColumn: "6/7",
    width: "50px",
};
var HR = styled.hr(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  grid-column: 1/7;\n  width: 100%;\n"], ["\n  grid-column: 1/7;\n  width: 100%;\n"])));
var countryOptions = [
    { value: "United States of America", label: "United States" },
    { value: "Afganistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "American Samoa", label: "American Samoa" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Anguilla", label: "Anguilla" },
    { value: "Antigua & Barbuda", label: "Antigua & Barbuda" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Aruba", label: "Aruba" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bermuda", label: "Bermuda" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bonaire", label: "Bonaire" },
    { value: "Bosnia & Herzegovina", label: "Bosnia & Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brazil", label: "Brazil" },
    { value: "British Indian Ocean Ter", label: "British Indian Ocean Ter" },
    { value: "Brunei", label: "Brunei" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina Faso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Canary Islands", label: "Canary Islands" },
    { value: "Cape Verde", label: "Cape Verde" },
    { value: "Cayman Islands", label: "Cayman Islands" },
    { value: "Central African Republic", label: "Central African Republic" },
    { value: "Chad", label: "Chad" },
    { value: "Channel Islands", label: "Channel Islands" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Christmas Island", label: "Christmas Island" },
    { value: "Cocos Island", label: "Cocos Island" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    { value: "Cook Islands", label: "Cook Islands" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Cote DIvoire", label: "Cote DIvoire" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Curaco", label: "Curacao" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "East Timor", label: "East Timor" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Ethiopia", label: "Ethiopia" },
    { value: "Falkland Islands", label: "Falkland Islands" },
    { value: "Faroe Islands", label: "Faroe Islands" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "French Guiana", label: "French Guiana" },
    { value: "French Polynesia", label: "French Polynesia" },
    { value: "French Southern Ter", label: "French Southern Ter" },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Gibraltar", label: "Gibraltar" },
    { value: "Great Britain", label: "Great Britain" },
    { value: "Greece", label: "Greece" },
    { value: "Greenland", label: "Greenland" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guadeloupe", label: "Guadeloupe" },
    { value: "Guam", label: "Guam" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Hawaii", label: "Hawaii" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hong Kong", label: "Hong Kong" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "India", label: "India" },
    { value: "Iran", label: "Iran" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland", label: "Ireland" },
    { value: "Isle of Man", label: "Isle of Man" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Korea North", label: "Korea North" },
    { value: "Korea Sout", label: "Korea South" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    { value: "Laos", label: "Laos" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libya", label: "Libya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Macau", label: "Macau" },
    { value: "Macedonia", label: "Macedonia" },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Malawi", label: "Malawi" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Martinique", label: "Martinique" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mayotte", label: "Mayotte" },
    { value: "Mexico", label: "Mexico" },
    { value: "Midway Islands", label: "Midway Islands" },
    { value: "Moldova", label: "Moldova" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montserrat", label: "Montserrat" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Nambia", label: "Nambia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherland Antilles", label: "Netherland Antilles" },
    { value: "Netherlands", label: "Netherlands (Holland, Europe)" },
    { value: "Nevis", label: "Nevis" },
    { value: "New Caledonia", label: "New Caledonia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Niue", label: "Niue" },
    { value: "Norfolk Island", label: "Norfolk Island" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau Island", label: "Palau Island" },
    { value: "Palestine", label: "Palestine" },
    { value: "Panama", label: "Panama" },
    { value: "Papua New Guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Phillipines", label: "Philippines" },
    { value: "Pitcairn Island", label: "Pitcairn Island" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Puerto Rico", label: "Puerto Rico" },
    { value: "Qatar", label: "Qatar" },
    { value: "Republic of Montenegro", label: "Republic of Montenegro" },
    { value: "Republic of Serbia", label: "Republic of Serbia" },
    { value: "Reunion", label: "Reunion" },
    { value: "Romania", label: "Romania" },
    { value: "Russia", label: "Russia" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "St Barthelemy", label: "St Barthelemy" },
    { value: "St Eustatius", label: "St Eustatius" },
    { value: "St Helena", label: "St Helena" },
    { value: "St Kitts-Nevis", label: "St Kitts-Nevis" },
    { value: "St Lucia", label: "St Lucia" },
    { value: "St Maarten", label: "St Maarten" },
    { value: "St Pierre & Miquelon", label: "St Pierre & Miquelon" },
    { value: "St Vincent & Grenadines", label: "St Vincent & Grenadines" },
    { value: "Saipan", label: "Saipan" },
    { value: "Samoa", label: "Samoa" },
    { value: "Samoa American", label: "Samoa American" },
    { value: "San Marino", label: "San Marino" },
    { value: "Sao Tome & Principe", label: "Sao Tome & Principe" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra Leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon Islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South Africa", label: "South Africa" },
    { value: "Spain", label: "Spain" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Swaziland", label: "Swaziland" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syria", label: "Syria" },
    { value: "Tahiti", label: "Tahiti" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tajikistan", label: "Tajikistan" },
    { value: "Tanzania", label: "Tanzania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tokelau", label: "Tokelau" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad & Tobago", label: "Trinidad & Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Turks & Caicos Is", label: "Turks & Caicos Is" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United Arab Erimates", label: "United Arab Emirates" },
    { value: "Uraguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatican City State", label: "Vatican City State" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Virgin Islands (Brit)", label: "Virgin Islands (Brit)" },
    { value: "Virgin Islands (USA)", label: "Virgin Islands (USA)" },
    { value: "Wake Island", label: "Wake Island" },
    { value: "Wallis & Futana Is", label: "Wallis & Futana Is" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zaire", label: "Zaire" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
];
var stateOptions = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "D.C." },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
];
var MIN_YEAR = new Date().getFullYear().toString().slice(-2);
var PaymentForm = function (_a) {
    var values = _a.values, membershipMonthLabel = _a.membershipMonthLabel, membershipYearLabel = _a.membershipYearLabel, onChange = _a.onChange, onSubmit = _a.onSubmit, reCaptchaKey = _a.reCaptchaKey, _b = _a.isNewUser, isNewUser = _b === void 0 ? true : _b, imageSrc = _a.imageSrc, _c = _a.imageMaxWidth, imageMaxWidth = _c === void 0 ? "300px" : _c;
    var _d = useState(null), passwordError = _d[0], setPasswordError = _d[1];
    var _e = useState(""), reCaptchaValue = _e[0], setReCaptchaValue = _e[1];
    var _f = useState(true), isSubmitDisabled = _f[0], setSubmitDisabled = _f[1];
    useEffect(function () {
        if (!values.billingState) {
            values.billingState = "CO";
        }
        if (!values.billingCountry) {
            values.billingCountry = "United States of America";
        }
    }, [values]);
    var handleChange = useCallback(function (e) {
        if (onChange) {
            var args = { name: e.target.name, value: e.target.value, event: e };
            onChange(args);
        }
    }, [onChange]);
    var handleChangeCardNumber = useCallback(function (value) {
        if (onChange) {
            var args = { name: "cardNumber", value: value, event: null };
            onChange(args);
        }
    }, [onChange]);
    var handlePasswordChange = useCallback(function (e) {
        switch (e.target.name) {
            case "password":
                if (e.target.value !== values.passwordConfirm) {
                    setPasswordError("Passwords do not match");
                }
                else {
                    setPasswordError(null);
                }
                break;
            case "passwordConfirm":
                if (e.target.value !== values.password) {
                    setPasswordError("Passwords do not match");
                }
                else {
                    setPasswordError(null);
                }
                break;
            default:
                break;
        }
        if (onChange) {
            var args = { name: e.target.name, value: e.target.value, event: e };
            onChange(args);
        }
    }, [values.passwordConfirm, values.password, onChange]);
    var handleReCaptchaSuccess = useCallback(function (value) {
        setReCaptchaValue(value);
        setSubmitDisabled(false);
    }, []);
    var handleReCaptchaFail = useCallback(function () {
        setSubmitDisabled(true);
    }, []);
    var handleSubmit = useCallback(function (e) {
        e.preventDefault();
        if (!passwordError)
            if (onSubmit) {
                onSubmit(__assign(__assign({}, values), { reCaptchaValue: reCaptchaValue }));
            }
    }, [passwordError, onSubmit, values, reCaptchaValue]);
    return (React.createElement(Form, null,
        imageSrc ? React.createElement(Image, { src: imageSrc, "$maxWidth": imageMaxWidth }) : undefined,
        React.createElement(Header, null, "Join Now"),
        React.createElement(HR, null),
        React.createElement(Header, null, "Payment Type"),
        React.createElement(RadioWrapper, null,
            React.createElement(RadioInput, { checked: values.paymentType === "card", name: "paymentType", value: "card", label: "Credit/Debit Card", inputSize: "large", style: firstHalfColumns, onChange: handleChange }),
            React.createElement(RadioInput, { checked: values.paymentType === "accessCode", name: "paymentType", value: "accessCode", label: "Access Code", inputSize: "large", style: secondHalfColumns, onChange: handleChange })),
        React.createElement(HR, null),
        React.createElement(Header, null, "Membership Information"),
        values.paymentType === "accessCode" ? (React.createElement(React.Fragment, null,
            React.createElement(TextInput, { style: firstHalfColumns, inputSize: "large", label: "First Name", placeholder: "first name", name: "billingFirstName", value: values.billingFirstName, onChange: handleChange, required: true }),
            React.createElement(TextInput, { style: secondHalfColumns, inputSize: "large", label: "Last Name", placeholder: "last name", name: "billingLastName", value: values.billingLastName, onChange: handleChange, required: true }))) : (React.createElement(React.Fragment, null)),
        React.createElement(TextInput, { inputSize: "large", label: "Email", name: "email", value: values.email, onChange: handleChange, style: allColumns, required: true, placeholder: "email", disabled: !isNewUser }),
        isNewUser && (React.createElement(React.Fragment, null,
            React.createElement(PasswordInput, { inputSize: "large", label: "Password", name: "password", value: values.password, onChange: handleChange, style: allColumns, required: true, placeholder: "password" }),
            React.createElement(PasswordInput, { inputSize: "large", label: "Confirm Password", name: "passwordConfirm", value: values.passwordConfirm, onChange: handlePasswordChange, style: allColumns, required: true, placeholder: "password confirmation", errorText: passwordError }))),
        values.paymentType !== "accessCode" ? (React.createElement(RadioWrapper, null,
            React.createElement(RadioInput, { checked: values.membership === "12", name: "membership", value: "12", label: membershipYearLabel, inputSize: "large", style: firstHalfColumns, onChange: handleChange }),
            React.createElement(RadioInput, { checked: values.membership === "1", name: "membership", value: "1", label: membershipMonthLabel, inputSize: "large", style: secondHalfColumns, onChange: handleChange }))) : (React.createElement(React.Fragment, null)),
        React.createElement(HR, null),
        values.paymentType === "card" ? (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Payment Information"),
            React.createElement(CardInput, { inputSize: "large", label: "Card Number", name: "cardNumber", value: values.cardNumber, onCardChange: handleChangeCardNumber, style: allColumns, required: true, placeholder: "#### #### #### ####" }),
            React.createElement(ExpirationWrapper, null,
                React.createElement(NumberInput, { style: expirationStyles, label: "Expires", placeholder: "MM", name: "cardExpirationMonth", value: values.cardExpirationMonth, onChange: handleChange, min: "1", max: "12", helpText: "MM", inputSize: "large", required: true }),
                React.createElement(NumberInput, { style: expirationStyles, name: "cardExpirationYear", placeholder: "YY", value: values.cardExpirationYear, onChange: handleChange, min: MIN_YEAR, max: "99", helpText: "YY", inputSize: "large", required: true })),
            React.createElement(TextInput, { inputSize: "large", label: "CVV", placeholder: "###", name: "cardCvv", value: values.cardCvv, onChange: handleChange, style: cvvStyles, required: true }))) : (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Access Code"),
            React.createElement(TextInput, { style: allColumns, inputSize: "large", label: "Access Code", placeholder: "enter code here", name: "accessCode", value: values.accessCode, onChange: handleChange, required: true }))),
        values.paymentType !== "accessCode" ? (React.createElement(React.Fragment, null,
            React.createElement(HR, null),
            React.createElement(Header, null, "Billing Information"),
            React.createElement(TextInput, { style: firstHalfColumns, inputSize: "large", label: "First Name", placeholder: "first name", name: "billingFirstName", value: values.billingFirstName, onChange: handleChange, required: true }),
            React.createElement(TextInput, { style: secondHalfColumns, inputSize: "large", label: "Last Name", placeholder: "last name", name: "billingLastName", value: values.billingLastName, onChange: handleChange, required: true }),
            React.createElement(TextInput, { inputSize: "large", label: "Address", name: "billingAddress1", value: values.billingAddress1, onChange: handleChange, style: allColumns, required: true, placeholder: "address" }),
            React.createElement(TextInput, { inputSize: "large", label: "Apartment/Building/Suite (Optional)", name: "billingAddress2", value: values.billingAddress2 || "", onChange: handleChange, style: allColumns, placeholder: "address 2" }),
            React.createElement(TextInput, { inputSize: "large", label: "Company Name (Optional)", name: "billingCompany", value: values.billingCompany || "", onChange: handleChange, style: allColumns, placeholder: "company" }),
            React.createElement(TextInput, { style: firstHalfColumns, inputSize: "large", label: "City", placeholder: "city", name: "billingCity", value: values.billingCity, onChange: handleChange, required: true }),
            React.createElement(SelectInput, { style: secondHalfColumns, label: "State", required: true, inputSize: "large", name: "billingState", onChange: handleChange, value: values.billingState || "CO", options: stateOptions }),
            React.createElement(TextInput, { style: firstHalfColumns, inputSize: "large", label: "Postal Code", placeholder: "#####", name: "billingZipCode", value: values.billingZipCode, onChange: handleChange, required: true }),
            React.createElement(TextInput, { style: secondHalfColumns, inputSize: "large", label: "Phone", placeholder: "### ### ####", name: "billingPhone", value: values.billingPhone, onChange: handleChange }),
            React.createElement(SelectInput, { style: allColumns, label: "Country", required: true, inputSize: "large", name: "billingCountry", onChange: handleChange, value: values.billingCountry, options: countryOptions }))) : (React.createElement(React.Fragment, null)),
        React.createElement(ReCaptchaWrapper, null,
            React.createElement(ReCAPTCHA, { sitekey: reCaptchaKey, onChange: handleReCaptchaSuccess, onErrored: handleReCaptchaFail, onExpired: handleReCaptchaFail })),
        React.createElement(Button, { style: allColumns, type: "submit", onClick: handleSubmit, emphasis: "primary", isDisabled: isSubmitDisabled }, "Confirm")));
};
export default PaymentForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
